<template>
  <tr>
    <td class="middle">
      {{ index + 1 }}.
    </td>

    <w-table-cell :model="item.nip">
      <w-input :model="item.nip" />
    </w-table-cell>

    <td>
      <w-row-buttons :model="item" :move-up="index != 0" :move-down="item.$parent.$value.length - 1 !== index" />
    </td>
  </tr>
</template>

<script>
import components from '@witkac/bootstrap4-components';

// @vuese
// @De Minimis estimate row
// @Group detailsComponents
export default {
  components,
  props: {
    // Wartość przekazana do wypelnienia pola w schemacie
    item: { type: Object, required: true },

    // Indeks
    index: { type: Number, required: true }
  }
};
</script>
